import { UserForm } from './UserForms';
import { EmailNotificationSettings } from './EmailNotificationSettings';
import { useMsal } from '@azure/msal-react';
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import { AppUser, apiModelToAppUser } from "../../models/appUser";
import { SetValueOnObject } from "../../utils/UnsafeTypescriptUtil";
import { AppUserContext } from "../PvsContextProvider";
import { useNotificationAPI } from '../../components/NotificationProvider';
import { useEffect, useContext, useState } from "react";

const pageTitle = 'Settings Manager';

export const SettingsNavigation = () => {
    const context = useContext(AppUserContext);
    const { addNotification } = useNotificationAPI();
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const { isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });

    const [settingsMenu, setSettingsMenu] = useState("user");

    const getSettingsMenu = () => {
        if (settingsMenu === "user") {
            return <UserForm isLoading={isLoading} appUser={context.appUser} onChange_AppUser={onChange_AppUser}></UserForm>
        } else if (settingsMenu === "email") {
            return <EmailNotificationSettings isLoading={isLoading} appUser={context.appUser} onChange_AppUser={onChange_AppUser}></EmailNotificationSettings>
        }

        return <UserForm isLoading={isLoading} appUser={context.appUser} onChange_AppUser={onChange_AppUser}></UserForm>;
    }

    const onChange_AppUser = (e: any, propName: string) => {
        let updatedUser: AppUser = SetValueOnObject(context.appUser as object, propName, e.target.value) as AppUser;
        context.setAppUser(updatedUser);
    }

    const handleSubmit = () => {
        execute('PUT', protectedResources.apiAppUser.endpoint + "UpdateUser", context.appUser)
            .then(
                ((result: any) => {
                    if (result?.id) {
                        let resultAppUser = apiModelToAppUser(result);
                        context.setAppUser(resultAppUser);
                        if (context?.appUser !== undefined && context.appUser.AzureUserId === activeAccount?.localAccountId) {
                            context.setAppUser(resultAppUser);
                        }
                        addNotification("User updated successfully", pageTitle, "success")
                    }
                })
            );
    }

    const getAppUser = () => {
        if (context?.appUser !== undefined && context.appUser.Id > 0) {
            execute("GET", protectedResources.apiAppUser.endpoint + "GetUser/?Id=" + context.appUser.Id)
                .then(
                    ((result: any) => {
                        if (result) {
                            context.setAppUser(apiModelToAppUser(result));
                        }
                    })
                );
        }
    }
    
    useEffect(() => { getAppUser(); }, [execute]);

    return <>
        <div className="navigation-container">
            <div className="k-tilelayout-item-header k-card-header k-cursor-grab">
                <span className="dashboard-button" style={{ textDecoration: 'none' }} onClick={() => setSettingsMenu('user')}>
                    <button style={{ color: 'black' }} className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base" type="button">
                        <span className="k-icon k-i-user k-button-icon"></span>
                        <span className="k-button-text">
                            Account
                        </span>
                    </button>
                </span>

                <span className="dashboard-button" style={{ textDecoration: 'none' }} onClick={() => setSettingsMenu('email')}>
                    <button style={{ color: 'black' }} className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base" type="button" >
                        <span className="k-icon k-i-notification k-button-icon"></span>
                        <span className="k-button-text">Notifications
                        </span>
                    </button>
                </span>
            </div>
        </div>
        {getSettingsMenu()}
        <div>
            <button className="k-selected k-button k-button-md k-button-rectangle k-rounded-md k-button-solid k-button-solid-primary k-form-submit" onClick={handleSubmit}>
                Save Changes
            </button>
        </div>
    </>;
}